import { useLayoutEffect, useRef } from 'react';
import { ID } from '@/utils/enums';

const useLandingPageRefs = (apply: boolean) => {
  const mainRef = useRef<HTMLDivElement | null>(null);
  const successBoxRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const main = document.getElementById(ID.LANDING_PAGE_MAIN);
    const successBox = document.getElementById(ID.LANDING_PAGE_SUCCESS_BOX);
    if (main) mainRef.current = main as HTMLDivElement;
    if (successBox) successBoxRef.current = successBox as HTMLDivElement;
  }, [apply]);

  return { mainRef, successBoxRef };
};

export default useLandingPageRefs;
